import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import {LoginService, UserProfileService } from '../core';

@Injectable()
export class PrebuildLoginUserProfileService{
  public loginService:LoginService;

  constructor(public userProfileService: UserProfileService, private http:Http) {
    this.loginService = new LoginService(http, userProfileService);
  }

}
